// const initState = {
//     company: "",
//     client: "",
//     fy: "",
//     folder: "",
//     query: "",
// }

const initState = {
    company: {},
    client: {},
    fy: {},
    folder: {},
    query: {},
    primaryClient: {}
}

export const selectedReducer = (state = initState, action) => {
    switch (action.type) {
        case 'SET_SELECTED_COMPANY':
            return {
                ...state,
                company: action.payload ? action.payload : {}
            };
        case 'SET_SELECTED_CLIENT':
            return {
                ...state,
                client: action.payload ? action.payload : {}
            };
        case 'SET_SELECTED_FY':
            return {
                ...state,
                fy: action.payload ? action.payload : {}
            };
        case 'SET_SELECTED_FOLDER':
            return {
                ...state,
                folder: action.payload ? action.payload : {}
            };
        case 'SET_SELECTED_QUERY':
            return {
                ...state,
                query: action.payload
            };
        case 'SET_SELECTED_PRIMARY_CLIENT':
            console.log(action.payload)
            return {
                ...state,
                primaryClient: action.payload ? action.payload : {}
            }
        case 'RESET_SELECTIONS':
            return initState;
        default:
            return state;
    }
};